import { SCORE_JOKER_BOOSTER } from '../../../Constants/Score';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import {
    DEFAULT_CARD_HEIGHT,
    DEFAULT_CARD_WIDTH,
} from '../../../Prototype/Level/Card/ICardData';
import { Random } from '../../../Utility/Random';
import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setBoosterJoker } from '../../Player/PlayerInventoryHelper';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class JokerBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        const newCardID = `card_joker_${Random.ID()}`;

        state = CardStateHelper.addCard(state, {
            id: newCardID,
            type: CardType.joker,
            random: false,
            value: undefined,
            faceUp: true,
            sequence: 0,
            modifiers: [],
            attempts: 0,
            x: 0,
            y: 0,
            rotation: 0,
            depth: 0,
            width: DEFAULT_CARD_WIDTH,
            height: DEFAULT_CARD_HEIGHT,
        });

        state = CardStateHelper.setCardFolded(state, newCardID);

        // Buying a Joker increments the streak.
        state = CardStateHelper.increaseStreak(state, SCORE_JOKER_BOOSTER);

        state = CardStateHelper.checkStreakBonus(state);

        // Task for animation.
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.JOKER,
            cards: [newCardID],
        });

        // Clear the undo history when a joker is played.
        state = CardStateHelper.clearUndoHistory(state);

        return this.consumeItemOrCoins(state);
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices.joker;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory.boosterJoker;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        gameTracking(FBTrackingEvent.TapOnJokerCard);
        track('mJokerUsed', 1, TrackMethod.ADD);
        track('tJokerUsed', 1, TrackMethod.ADD);
        trackTransaction(
            state,
            TransactionType.INVENTORY,
            TActionType.BOOSTER_USE
        );

        return {
            ...state,
            playerState: setBoosterJoker(
                state.playerState,
                state.playerState.inventory.boosterJoker - 1,
                false
            ),
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        track('tJokerReceived', 1, TrackMethod.ADD);
        track('tJokerUsed', 1, TrackMethod.ADD);
        state = super.spendCoins(state);

        gameTracking(FBTrackingEvent.TapOnJokerCard);
        track('mJokerUsed', 1, TrackMethod.ADD);

        return state;
    }

    /**
     * Ensure that the current card is not already a joker.
     * @param state
     */
    public isPlayable(state: IGameState): boolean {
        const topCardID = CardStateHelper.getCurrentCard(state);
        const topCard = state.levelState.cardsState.cards[topCardID];

        return (
            super.isPlayable(state) &&
            (!topCard || topCard.type !== CardType.joker)
        );
    }
}
